var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5013 20.0534C15.6805 18.9273 15.6805 17.0727 14.5013 15.9467L14.3401 15.7929C11.3175 12.908 8.98249 10.6804 8.27863 6.01098C8.0296 4.3645 9.44025 3 11.138 3H18H24.8622C26.5599 3 27.9705 4.3645 27.7215 6.01098C27.0177 10.6804 24.6826 12.908 21.66 15.7929L21.4989 15.9467C20.3196 17.0727 20.3196 18.9273 21.4989 20.0534L21.66 20.2071C24.6826 23.0921 27.0177 25.3197 27.7215 29.9891C27.9705 31.6355 26.5599 33 24.8622 33H18H11.138C9.44025 33 8.0296 31.6355 8.27863 29.9891C8.98249 25.3197 11.3175 23.0921 14.3401 20.2071L14.5013 20.0534ZM15.5259 22.5998L15.5149 22.6092C13.2115 24.6689 11.4976 26.2022 11.2742 29.9945C11.2603 30.2279 11.3614 30.4373 11.5262 30.576C11.6544 30.6846 11.8221 30.75 12.0052 30.75H18H23.9941C24.2103 30.75 24.4051 30.6588 24.5391 30.5133C24.6643 30.3777 24.7369 30.195 24.7251 29.9945C24.5017 26.2022 22.7878 24.6689 20.4852 22.6092C19.8757 22.0644 19.2253 21.4827 18.5508 20.8127C18.2469 20.5107 17.7525 20.5107 17.4486 20.8127C16.7776 21.4788 16.131 22.0578 15.5259 22.5998Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hour-glass.b5ec297a1bfbf9f010e696b30276b640.svg";
export { ForwardRef as ReactComponent };